"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEvent = void 0;

var _react = _interopRequireDefault(require("react"));

var _useLayoutEffectSSRSafe = require("./useLayoutEffectSSRSafe");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable @typescript-eslint/no-explicit-any */

/** Experimental implementation of the upcoming useEvent hook:  https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md */
var useEvent = function useEvent(handler) {
  var handlerRef = _react["default"].useRef();

  (0, _useLayoutEffectSSRSafe.useLayoutEffectSSRSafe)(function () {
    handlerRef.current = handler;
  }); // Have to disable the rule below because eslint doesn't consider (()=>{}) as an inline function and it complains:
  // "React Hook useCallback received a function whose dependencies are unknown. Pass an inline function instead"
  // It used to work when the "inline" function didn't have the wrapping parentheses (required for the type assertion).
  // eslint-disable-next-line react-hooks/exhaustive-deps

  return _react["default"].useCallback(function () {
    var fn = handlerRef.current;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return fn === null || fn === void 0 ? void 0 : fn.apply(void 0, args);
  }, []);
};

exports.useEvent = useEvent;